import React from 'react';

const style = {
  subtitle: {
    fontSize: 28
  },
}

export default ({text}) => {
  return (
    <div style={style.subtitle}>{text}</div>
  )
};



// WEBPACK FOOTER //
// ./src/components/common/Subtitle.js